<!-- =========================================================================================
    File Name: VxSidebarItem.vue
    Description: Sidebar item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VxSidebarItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    :class="[
      { 'vs-sidebar-item-active': activeLink },
      { 'disabled-item pointer-events-none': isDisabled },
    ]"
    class="vs-sidebar--item"
  >
    <router-link
      v-if="to"
      :to="to"
      :class="[{ 'router-link-active': activeLink }]"
      :target="target"
      exact
      @click.native="setActiveAccount(to)"
    >
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon">
      </vs-icon>
      <feather-icon
        v-else-if="icon"
        :icon="icon"
        :class="{ 'w-3 h-3': iconSmall }"
      ></feather-icon>
      <slot></slot>
    </router-link>
    <a v-else :target="target">
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon">
      </vs-icon>
      <feather-icon
        v-else-if="icon"
        :icon="icon"
        :class="{ 'w-3 h-3': iconSmall }"
      ></feather-icon>
      <slot></slot>
    </a>
  </div>
</template>

<script>
export default {
  name: 'VxSidebarItem',
  props: {
    icon: {
      default: '',
      type: String,
    },
    iconSmall: {
      default: false,
      type: Boolean,
    },
    iconPack: {
      default: 'material-icons',
      type: String,
    },
    item: {
      type: Object,
    },
    href: {
      default: '#',
      type: String,
    },
    to: {
      default: null,
      type: String,
    },
    index: {
      default: null,
      type: [String, Number],
    },
    featherIcon: {
      default: true,
      type: Boolean,
    },
    target: {
      default: '_self',
      type: String,
    },
    isDisabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      activeLink: false,
    };
  },
  watch: {
    $route() {
      this.CheckIsActive();
    },
  },
  methods: {
    CheckIsActive() {
      if (this.to) {
        if (this.to == this.$router.path && this.to) {
          this.activeLink = true;
        } else {
          this.activeLink = false;
        }
        // if (this.$route.path.slice(1).includes(this.to.slice(1)) && this.to.slice(1)) this.activeLink = true
        // else this.activeLink = false
      }
    },
    setActiveAccount(to) {
      console.debug('setActiveAccount(): ', this.item);
      if (this.item && this.item.meta && this.item.meta.apiId) {
        console.debug(
          'setActiveAccount(): RouterLink on item clicked. Setting active account to ' +
            this.item.meta.apiId
        );
        this.$store.commit('SET_ACTIVE_ACCOUNT', this.item.meta.apiId);

        if (to && to !== this.$router.currentRoute.fullPath) {
          console.debug(
            'setActiveAccount(): router to: ',
            to,
            this.$router.currentRoute.fullPath
          );
          this.$router.push(to);
          // let self = this;
          // setTimeout(function () {
          //   self.$router.push(to);
          //
          // }, 5000);
        }
      }
    },
  },
  updated() {
    this.CheckIsActive();
  },
};
</script>
